import Vue from 'vue'
import vuetify from './plugins/vuetify'
import './plugins/vuefire'
import './plugins/maps'
import './styles/main.scss'

import router from './router';
import store from './store';

import assets from './plugins/assets.json'
Vue.prototype.$assets = assets

import App from './App.vue'

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App),
}).$mount('#app')
